/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_taxes = /** @type {(inputs: {}) => string} */ () => {
	return `Daně`
};

const da_taxes = /** @type {(inputs: {}) => string} */ () => {
	return `Moms`
};

const de_taxes = /** @type {(inputs: {}) => string} */ () => {
	return `Steuern`
};

const en_taxes = /** @type {(inputs: {}) => string} */ () => {
	return `Taxes`
};

const es_taxes = /** @type {(inputs: {}) => string} */ () => {
	return `Impuestos`
};

const fr_taxes = /** @type {(inputs: {}) => string} */ () => {
	return `Taxes`
};

const hu_taxes = /** @type {(inputs: {}) => string} */ () => {
	return `Adók`
};

const it_taxes = /** @type {(inputs: {}) => string} */ () => {
	return `Tasse`
};

const nl_taxes = /** @type {(inputs: {}) => string} */ () => {
	return `Belastingen`
};

const pl_taxes = /** @type {(inputs: {}) => string} */ () => {
	return `Podatki`
};

const pt_taxes = /** @type {(inputs: {}) => string} */ () => {
	return `Impostos`
};

const sv_taxes = /** @type {(inputs: {}) => string} */ () => {
	return `Skatter`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const taxes = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.taxes(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("taxes", locale)
	if (locale === "cs") return cs_taxes(inputs)
	if (locale === "da") return da_taxes(inputs)
	if (locale === "de") return de_taxes(inputs)
	if (locale === "en") return en_taxes(inputs)
	if (locale === "es") return es_taxes(inputs)
	if (locale === "fr") return fr_taxes(inputs)
	if (locale === "hu") return hu_taxes(inputs)
	if (locale === "it") return it_taxes(inputs)
	if (locale === "nl") return nl_taxes(inputs)
	if (locale === "pl") return pl_taxes(inputs)
	if (locale === "pt") return pt_taxes(inputs)
	return sv_taxes(inputs)
};